import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable()
export class CustomerRequestService extends BaseApiService {

    public getCustomerRequestQueueData() {
        return this.get('Customer/Request/QueueData');
    }

    public getCustomerRequest(customerRequestId: number) {
        return this.get('Customer/Request/' + customerRequestId);
    }

    public assignCustomerRequestToUser(customerRequestId: number, userLoginId: number) {
        return this.post('Customer/Request/' + customerRequestId + '/AssignedTo/' + (userLoginId ? userLoginId : ''), null);
    }

    public changeCustomerRequestStatus(customerRequestId: number, statusId: number) {
        return this.post('Customer/Request/' + customerRequestId + '/Status/' + statusId, null);
    }
}
